import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {deriveStepUiSchema} from 'pipelines/generalized-step-config-editor/step-config-settings/deriveStepUiSchema';
import {getStepTypeConfigShape} from 'pipelines/StepShapeUtils';

import {StepTypeConfigUISchemaV2} from '../step-config-settings/StepConfigUISchemas';

const IMPORT_PLATES_BASE_UI_SCHEMA = deriveStepUiSchema(
  getStepTypeConfigShape(PipelineStepType.IMPORT_PLATES, 0).fields
);

export const IMPORT_PLATES_V0_UI_SCHEMA = {
  ...IMPORT_PLATES_BASE_UI_SCHEMA,
  scratchPlateIds: {
    ...IMPORT_PLATES_BASE_UI_SCHEMA.scratchPlateIds,
    displayName: 'Plate IDs or barcodes',
  },
} as StepTypeConfigUISchemaV2<PipelineStepType.IMPORT_PLATES, 0>;
